// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_l8-0";